import { BASE_URL_ANALYTICS } from '@frontend/api-analytics';

export const API_URLs = {
  missedCallText: {
    appointmentScheduledSummary: `${BASE_URL_ANALYTICS}/roi/getmissedcalltext`,
    messagesSentSummart: `${BASE_URL_ANALYTICS}/roi/getmissedcalltextmessages`,
    practiceValueSummary: `${BASE_URL_ANALYTICS}/roi/getmissedcalltextapptscompleted`,
  },
};
